import React from "react";
import { string } from "prop-types";

import Tooltip from "../../../../shared/seller-services/components/Tooltip";
import { useValuationStoreData } from "../../utilities/mobx/storeHooks";
import ValuationContainer from "../ValuationContainer";
import * as S from "./styled";

const Valuation = ({ className }) => {
  const {
    areaName,
    price,
    pricePerSquareFoot,
    pricePerSquareFootInArea,
    priceRangeEnd,
    priceRangeStart,
    rentPrice
  } = useValuationStoreData();

  return (
    <ValuationContainer className={className}>
      <S.ValuationContent>
        <S.Price>{price}</S.Price>
        <S.Label>
          <S.LabelText>Estimated Price Range: </S.LabelText>
          <S.Value>
            {priceRangeStart} - {priceRangeEnd}
          </S.Value>
        </S.Label>
        {pricePerSquareFoot && (
          <>
            <S.Spacer />
            <S.Label>
              <S.LabelText>Estimated Price per ft²: </S.LabelText>
              <S.Value>{pricePerSquareFoot}</S.Value>
            </S.Label>
          </>
        )}

        {pricePerSquareFootInArea && (
          <>
            <S.Spacer />
            <S.Label>
              <S.LabelText>Estimated Price per ft² in {areaName}: </S.LabelText>
              <S.Value>{pricePerSquareFootInArea} </S.Value>
            </S.Label>
          </>
        )}
        {rentPrice && (
          <>
            <S.Spacer />
            <S.Label>
              <S.LabelText>Estimated Rent: </S.LabelText>
              <span>
                <S.Value>{rentPrice}</S.Value>/mo
              </span>
              <S.TooltipContainer>
                <Tooltip title="Estimated Rent" titleVisible>
                  A Rent estimate is StreetEasy’s estimate of a property’s
                  monthly rental price. It is computed using a formula and is a
                  starting point in determining the monthly rental price for a
                  specific property.
                </Tooltip>
              </S.TooltipContainer>
            </S.Label>
          </>
        )}
      </S.ValuationContent>
    </ValuationContainer>
  );
};

Valuation.propTypes = {
  className: string
};

Valuation.defaultProps = {
  className: ""
};

export default Valuation;
